import { apiClient } from '@app/api';
import { AudiogramGenerateRequestDto } from '@app/modules/fragments/fragment.types';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { JobStatus } from '@mi-front/core';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import pick from 'lodash/pick';
import { useIntl } from 'react-intl';
import { audiogramHelpers, VariantWithJob } from '../helpers';
import { JobStatusAlert } from '../JobStatusAlert';
import { useFragment } from '../../../hooks/useFragment';

export function VariantGenerationStatus({ variant }: { variant: VariantWithJob }) {
  const { fragment } = useFragment();
  const { $t } = useIntl();
  const queryClient = useQueryClient();
  const job = variant.job;

  const mutation = useMutation({
    mutationFn: () =>
      apiClient.fragments.audiogramGenerate(
        fragment.id,
        pick(job.data, 'variants', 'inputProps') as AudiogramGenerateRequestDto,
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: useFragmentQuery.queryKey(fragment.id),
      });
    },
  });

  return (
    <Box mb={2}>
      <JobStatusAlert title={audiogramHelpers.getVariantName(variant.variant, $t)} job={job}>
        {job.status === JobStatus.FAILED && (
          <div>
            <div>
              <b>
                {$t({
                  id: 'common.error',
                  defaultMessage: 'Error',
                })}
              </b>{' '}
              {job.failedReason}
            </div>
            <Box mt={2}>
              <Button
                variant="outlined"
                size="small"
                color="inherit"
                onClick={() => mutation.mutate()}
                startIcon={<RefreshIcon />}
                loading={mutation.isPending}
              >
                {$t({
                  id: 'fragments.audiogram.regenerate',
                  defaultMessage: 'Generar nuevamente',
                })}
              </Button>
            </Box>
          </div>
        )}
      </JobStatusAlert>
    </Box>
  );
}
